/**
 * Stories handled by ZillowNavbar
 */
/* eslint-disable local-rules/require-storybook-documentation */
import { FunctionComponent, useCallback, useState } from 'react';
import { HeaderMegaMenuData } from 'src/components/ZillowNavbar/page-frame-types/HeaderMegaMenuData';
import { NoDataAvailable } from 'src/components/ZillowNavbar/page-frame-types/NoDataAvailable';
import { HEADER_VERSIONS } from 'src/components/ZillowNavbar/constants';
import { MobileDropdownMenuSection } from './components/MobileDropdownMenuSection';
import { MobileDropdownMenuSectionList } from './components/MobileDropdownMenuSectionList';

export type ZillowNavbarMobileDropdownMenuSectionsProps = {
    links: HeaderMegaMenuData | NoDataAvailable;
    zhlHost: string;
    version: HEADER_VERSIONS;
};

export const MobileDropdownMenuSections: FunctionComponent<ZillowNavbarMobileDropdownMenuSectionsProps> = ({
    links,
    zhlHost,
    version,
}) => {
    const [expandedSection, setExpandedSection] = useState<null | string>(null);
    const onSectionToggle = useCallback(
        (section: string) => {
            if (expandedSection === section) {
                setExpandedSection(null);
                return;
            }
            setExpandedSection(section);
        },
        [expandedSection]
    );
    if (!links) {
        return null;
    }
    const { sections } = links;

    return (
        <MobileDropdownMenuSectionList>
            {sections.map(section => (
                <MobileDropdownMenuSection
                    version={version}
                    isExpanded={section.link.text === expandedSection}
                    onSectionToggle={onSectionToggle}
                    zhlHost={zhlHost}
                    section={section}
                    key={section.link.text}
                />
            ))}
        </MobileDropdownMenuSectionList>
    );
};
